import {createSlice} from "@reduxjs/toolkit";

// Initial state, NOTE: user_type --> 1 = user , 2 = agent
const initialState = {
  user: null,
  user_type: null,
  isAuthorised: false,
  isLoggedIn: false,
  isApproved: false,
  isVerified: false,
  notificationCount: 0,
  notificationList: [],
  currency: "$",
  user_id: null,
  dashboardData: null,
  agentClientsData: [],
  selectedClient: null,
};

// Actual Slice
export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // Action to set the authentication status
    setAuthState(state, action) {
      state.authState = action.payload;
    },
    setAuthData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const {setAuthState, setAuthData} = authSlice.actions;

export const selectAuthState = (state) => state.auth;

export default authSlice.reducer;
